import { Translation, QRType } from '../types';

export const th: Translation = {
  nav: {
    generator: 'สร้างโค้ด',
    scanner: 'สแกนเนอร์',
    mobile: 'ลองบนมือถือ',
    blog: 'บล็อก',
    langSelect: 'เลือกภาษา',
  },
  pageTitles: {
    generator: 'เครื่องสร้างคิวอาร์โค้ดออนไลน์ฟรี',
    scanner: 'ตัวสแกนคิวอาร์โค้ดออนไลน์',
    textToQr: 'แปลงข้อความเป็นคิวอาร์โค้ด',
    linkToQr: 'สร้างคิวอาร์โค้ดจากลิงก์',
  },
  pageMeta: {
    generator: {
      title:
        'เครื่องสร้างคิวอาร์โค้ดฟรี — สร้าง QR Code ออนไลน์ (ไม่ต้องสมัคร ไม่มีลายน้ำ รองรับ PNG/SVG/PDF) | YesQRCode',
      description:
        'สร้างคิวอาร์โค้ดออนไลน์ฟรีกับ YesQRCode สร้างลิงก์ ข้อความ WiFi vCard และอื่น ๆ ได้ทันที ดาวน์โหลด PNG, SVG หรือ PDF ความละเอียดสูงได้ฟรี ไม่มีการสมัคร ไม่มีการล็อกอิน ไม่มีลายน้ำ — รวดเร็ว ปลอดภัย และฟรีเสมอ.',
      keywords: [
        'เครื่องสร้างคิวอาร์โค้ด',
        'สร้างคิวอาร์โค้ดฟรี',
        'สร้าง qr code ออนไลน์',
        'ตัวทำ qr code',
        'qr code png',
        'qr code svg',
        'qr code pdf',
        'ตัวสร้างคิวอาร์ wifi',
        'ตัวสร้างคิวอาร์ vcard',
        'ตัวสร้าง qr ไม่ต้องสมัคร',
      ],
    },
    scanner: {
      title:
        'สแกนเนอร์คิวอาร์โค้ดออนไลน์ — สแกนจากรูปหรือกล้อง (ปลอดภัย ไม่ต้องสมัคร) | YesQRCode',
      description:
        'สแกนคิวอาร์โค้ดและบาร์โค้ดออนไลน์ได้ฟรี อัปโหลดรูปหรือใช้กล้องได้ ประมวลผลทุกอย่างภายในเครื่อง ไม่มีการอัปโหลดข้อมูล ปลอดภัย รวดเร็ว ไม่ต้องสมัคร ไม่ต้องล็อกอิน และฟรีทั้งหมด.',
      keywords: [
        'สแกนคิวอาร์โค้ด',
        'สแกน qr ออนไลน์',
        'ตัวอ่าน qr ออนไลน์',
        'สแกน qr จากรูป',
        'สแกนบาร์โค้ดออนไลน์',
        'สแกนเนอร์ qr ปลอดภัย',
        'สแกน qr ไม่ต้องอัปโหลด',
        'สแกน qr ฟรี',
        'สแกน qr ผ่านเบราว์เซอร์',
        'สแกน qr ไม่ต้องสมัคร',
        'สแกน qr ไม่ต้องล็อกอิน',
      ],
    },
    textToQr: {
      title: 'แปลงข้อความเป็นคิวอาร์โค้ด — สร้าง QR จากข้อความได้ทันที | YesQRCode',
      description:
        'เปลี่ยนโน้ต ข้อความ หรือคำสั่งสั้น ๆ ให้เป็นคิวอาร์โค้ดออนไลน์ ปรับแต่งสี กรอบ และโลโก้ได้ครบ แล้วดาวน์โหลดไฟล์ PNG, SVG หรือ PDF ได้ฟรีโดยไม่ต้องสมัครสมาชิก.',
      keywords: [
        'ข้อความเป็นคิวอาร์โค้ด',
        'แปลงข้อความเป็น qr',
        'ตัวสร้าง qr ข้อความ',
        'qr code สำหรับข้อความ',
        'โน้ตเป็นคิวอาร์',
        'ข้อความ qr ออนไลน์',
        'ข้อความ qr ฟรี',
        'ข้อความ qr ไม่ต้องสมัคร',
        'text qr thai',
        'ข้อความ qr code',
      ],
    },
    linkToQr: {
      title: 'ตัวสร้างคิวอาร์จากลิงก์ — แปลง URL เป็น QR Code (รองรับ UTM) | YesQRCode',
      description:
        'วางลิงก์เว็บไซต์หรือแคมเปญใด ๆ แล้วรับคิวอาร์โค้ดพร้อมแบรนด์ได้ทันที ปรับแต่งสี โลโก้ และกรอบ พร้อมดาวน์โหลดไฟล์ความละเอียดสูงโดยไม่ต้องล็อกอิน.',
      keywords: [
        'ลิงก์เป็นคิวอาร์โค้ด',
        'แปลง url เป็น qr',
        'qr code สำหรับเว็บไซต์',
        'ตัวสร้าง qr ลิงก์',
        'utm qr code',
        'qr ลิงก์ฟรี',
        'qr สำหรับแคมเปญ',
        'url qr ไม่ต้องสมัคร',
        'ลิงก์ qr ออนไลน์',
        'qr code เว็บ',
      ],
    },
  },
  hero: {
    title: 'สร้าง สแกน ออกแบบ',
    subtitle: 'เครื่องมือคิวอาร์โค้ดระดับพรีเมียมสำหรับทุกคน',
    desc: 'สร้างคิวอาร์โค้ดที่ปรับแต่งได้เต็มรูปแบบพร้อมโลโก้ สี และไฟล์ความละเอียดสูงในทันที',
  },
  info: {
    helpTitle: 'ศูนย์ช่วยเหลือ',
    helpSubtitle: 'คำถามพบบ่อยและการสนับสนุน',
    contactTitle: 'ติดต่อเรา',
    contactSubtitle: 'ยินดีตอบกลับทุกข้อความ',
    privacyTitle: 'นโยบายความเป็นส่วนตัว',
    termsTitle: 'ข้อกำหนดการใช้งาน',
  },
  contactForm: {
    name: 'ชื่อ',
    email: 'อีเมล',
    message: 'ข้อความ',
    send: 'ส่งข้อความ',
    orEmail: 'หรือส่งอีเมลมาที่',
    sending: 'กำลังส่ง...',
    successTitle: 'ส่งเรียบร้อย!',
    successMessage: 'ขอบคุณสำหรับข้อความ เราจะติดต่อกลับโดยเร็วที่สุด',
    sendAnother: 'ส่งข้อความเพิ่ม',
    errorMessage: 'ไม่สามารถส่งข้อความได้ในขณะนี้ กรุณาอีเมลมาที่ support@yesqrcode.com',
  },
  generator: {
    highlights: {
      title: 'สร้างคิวอาร์โค้ดส่วนตัวพร้อมใช้กับแบรนด์ — ฟรีตลอดไป',
      subtitle: 'เครื่องมือคิวอาร์ที่รวดเร็ว ปลอดภัย และยืดหยุ่นสำหรับทุกเวิร์กโฟลว์',
      desc: 'สร้างและสแกนคิวอาร์คุณภาพสูงโดยไม่ต้องมีบัญชี ไม่มีลายน้ำ และไม่ต้องอัปโหลดข้อมูล',
      items: [
        {
          title: 'ความเป็นส่วนตัวมาเป็นอันดับแรก',
          desc: 'คิวอาร์ถูกสร้างบนอุปกรณ์ของคุณ — ไม่มีการอัปโหลด ติดตาม หรือเก็บข้อมูล',
        },
        {
          title: 'ฟีเจอร์ครบทุกการใช้งาน',
          desc: 'รองรับ URL, Wi-Fi, vCard, บาร์โค้ด, โลโก้, กราดิเอนต์ และกรอบในตัว',
        },
        {
          title: 'ใช้งานง่ายบนมือถือ',
          desc: 'ออกแบบมาสำหรับโทรศัพท์และการสัมผัส เพื่อให้การสร้างและสแกนลื่นไหล',
        },
        {
          title: 'ฟรีตลอดไป ปลอดภัยสำหรับธุรกิจ',
          desc: 'ไม่ต้องมีบัญชี ไม่มีลายน้ำ และไม่มีข้อจำกัดการสแกน — เหมาะกับทุกทีม',
        },
      ],
    },
    featureSuite: {
      title: 'ชุดเครื่องมือคิวอาร์โค้ดครบวงจรที่เน้นความเป็นส่วนตัว',
      subtitle: 'ทุกอย่างที่ต้องใช้ในการสร้างคิวอาร์สะอาด เรียบหรู และมีแบรนด์ อยู่ในที่เดียว',
      categories: [
        {
          title: 'รองรับทุกประเภทคิวอาร์',
          body: 'URL, ข้อความ, Wi-Fi, อีเมล, โทรศัพท์, SMS, vCard, ลิงก์โซเชียล, YouTube และบาร์โค้ด — โค้ดสแตติกที่ไม่หมดอายุ',
          items: [],
        },
        {
          title: 'การปรับแต่งแบรนด์และดีไซน์',
          body: 'รองรับโลโก้ กราดิเอนต์ กรอบ รูปทรง มุม และเลย์เอาต์ที่สแกนง่าย',
          items: [],
        },
        {
          title: 'คุณภาพไฟล์และการส่งออก',
          body: 'ส่งออก PNG, SVG และ PDF ความละเอียดสูง พร้อมพรีเซ็ตสำหรับงานพิมพ์และดิจิทัล',
          items: [],
        },
        {
          title: 'รองรับการใช้งานระดับโลก',
          body: 'อินเทอร์เฟซหลายภาษา ดีไซน์แบบ Mobile-first และเวิร์กโฟลว์ที่ใช้งานได้แม้ออฟไลน์',
          items: [],
        },
      ],
    },
    trust: {
      title: 'Trusted by creators, teams, and brands',
      subtitle:
        'YesQRCode is designed to be lightweight, predictable, and safe for long-running campaigns — with no accounts, no vendor lock-in, and no hidden limitations.',
      items: [
        'Zero onboarding',
        'Predictable static codes',
        'Enterprise-safe: no cloud processing',
        'Consistent branding across all assets',
      ],
    },
    sectionContent: 'เนื้อหา',
    sectionColors: 'สี',
    sectionLogo: 'โลโก้',
    sectionFrame: 'กรอบ',
    sectionDesign: 'ดีไซน์',
    sectionCorrection: 'การแก้ไขข้อผิดพลาด',
    labelUrl: 'ลิงก์เว็บไซต์',
    labelText: 'ข้อความ',
    labelSsid: 'ชื่อเครือข่าย (SSID)',
    labelPassword: 'รหัสผ่าน',
    labelEncryption: 'การเข้ารหัส',
    labelFgColor: 'สีหลัก',
    labelBgColor: 'พื้นหลัง',
    labelFrameText: 'ข้อความบนกรอบ',
    labelFrameColor: 'สีกรอบ',
    placeholder: 'พิมพ์เนื้อหาที่นี่...',
    placeholders: {
      url: 'https://example.com',
      text: 'พิมพ์ข้อความ',
      email: 'you@email.com',
      subject: 'หัวข้อ',
      message: 'ข้อความของคุณ...',
      phone: '+66 80 000 0000',
      ssid: 'MyWiFi',
      password: 'รหัสผ่าน',
      barcode: '123456789012',
    },
    download: 'ดาวน์โหลด PNG',
    downloadSvg: 'ดาวน์โหลด SVG',
    generateButton: 'สร้างคิวอาร์โค้ด',
    copy: 'คัดลอก SVG',
    uploadLogo: 'อัปโหลดรูป',
    preview: 'ตัวอย่าง',
    lowQuality: 'ความละเอียดต่ำ',
    highQuality: 'ความละเอียดสูง',
    foreverFree: 'ฟรีตลอดไป • ไม่ต้องสมัครสมาชิก • ใช้เชิงพาณิชย์ได้',
    barcodeWarning: 'คิวอาร์แบบบาร์โค้ดไม่รองรับโลโก้และกรอบ',
    barcodeColors: 'ยังสามารถปรับสีได้ตามต้องการ',
    frameStyles: {
      none: 'ไม่มีกรอบ',
      simple: 'เรียบง่าย',
      balloon: 'การ์ตูน',
      box: 'กล่อง',
      badge: 'ป้าย',
      polaroid: 'โพลารอยด์',
      phone: 'โทรศัพท์',
      header: 'หัวข้อ',
      corner: 'ขอบ',
    },
    vCard: {
      firstName: 'ชื่อ',
      lastName: 'นามสกุล',
      mobile: 'มือถือ',
      phone: 'โทรศัพท์',
      fax: 'แฟกซ์',
      email: 'อีเมล',
      company: 'บริษัท',
      job: 'ตำแหน่ง',
      street: 'ถนน',
      city: 'เมือง',
      zip: 'รหัสไปรษณีย์',
      state: 'จังหวัด',
      country: 'ประเทศ',
      website: 'เว็บไซต์',
    },
    types: {
      [QRType.URL]: 'URL',
      [QRType.TEXT]: 'ข้อความ',
      [QRType.EMAIL]: 'อีเมล',
      [QRType.PHONE]: 'โทรศัพท์',
      [QRType.SMS]: 'SMS',
      [QRType.WIFI]: 'Wi-Fi',
      [QRType.VCARD]: 'vCard',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: 'บาร์โค้ด',
    },
    guide: {
      title: 'สร้างคิวอาร์โค้ดแบบกำหนดเองอย่างไร',
      steps: [],
    },
    gettingStarted: {
      title: 'เริ่มต้นอย่างรวดเร็ว',
      steps: [
        { title: 'กำหนดเนื้อหา', text: 'เลือกประเภทคิวอาร์และกรอกข้อมูลที่ต้องการแสดงเมื่อสแกน' },
        { title: 'ปรับแต่งดีไซน์', text: 'เปลี่ยนสี รูปทรง และเพิ่มโลโก้ให้ตรงกับภาพลักษณ์แบรนด์' },
        { title: 'สร้างโค้ด', text: 'เลือกความละเอียด ดูตัวอย่างสด และทดสอบด้วยสแกนเนอร์ในตัว' },
        { title: 'ดาวน์โหลดใช้งาน', text: 'ได้ไฟล์ PNG หรือ SVG พร้อมใช้ในงานพิมพ์หรือสื่อดิจิทัล' },
      ],
    },
    about: {
      title: 'เครื่องมือสร้างคิวอาร์โค้ดฟรีคุณภาพมืออาชีพ',
      subtitle:
        'YesQRCode มาพร้อมไฟล์คมชัด ตัวเลือกดีไซน์หลากหลาย และคิวอาร์แบบสแตติกที่ไม่มีวันหมดอายุ',
      features: [
        'คิวอาร์สำหรับโซเชียลและหน้าแลนดิ้ง',
        'นามบัตรดิจิทัล (vCard)',
        'คุมสีและกรอบได้อย่างละเอียด',
        'ไฟล์พร้อมพิมพ์ความละเอียดสูง',
        'ใช้งานเชิงพาณิชย์ได้อย่างอิสระ',
        'สแกนได้ไม่จำกัดจำนวน',
      ],
      content: [
        { title: 'ไม่หมดอายุ', body: 'คิวอาร์แบบสแตติกทำงานได้ตลอด ไม่มีลิมิตการสแกน' },
        { title: 'ใส่โลโก้สบาย', body: 'ใช้ประโยชน์จากอัตราแก้ไขข้อผิดพลาด 30% เพื่อแปะโลโก้และยังสแกนได้ดี' },
        { title: 'ควบคุมดีไซน์เต็มที่', body: 'เลือกทรงโมดูล ไล่สี และกรอบที่ดึงดูดสายตา' },
        { title: 'รองรับงานพิมพ์', body: 'ไฟล์ PNG และ SVG ให้คุณนำไปใช้บนป้าย โบชัวร์ และบรรจุภัณฑ์ได้ทันที' },
        { title: 'ฟรีสำหรับธุรกิจ', body: 'ใช้ในแคมเปญ การตลาด หรือสินค้าของคุณโดยไม่มีค่าใช้จ่ายเพิ่มเติม' },
      ],
    },
    faq: {
      title: 'คำถามที่พบบ่อย',
      items: [
        { q: 'คิวอาร์โค้ดคืออะไร?', a: 'รหัสสองมิติที่เก็บข้อมูลลิงก์หรือข้อความเพื่อให้สแกนได้อย่างรวดเร็ว' },
        { q: 'ใช้งานฟรีหรือไม่?', a: 'ฟรี 100% สามารถสร้างได้ไม่จำกัด' },
        { q: 'ปรับข้อมูลภายหลังได้ไหม?', a: 'คิวอาร์เป็นแบบสแตติกจึงแก้ข้อความไม่ได้ ต้องสร้างใหม่' },
        { q: 'มีลิมิตการสแกนหรือไม่?', a: 'ไม่มีลิมิต สแกนได้ไม่จำกัด' },
        { q: 'ข้อมูลปลอดภัยหรือไม่?', a: 'ไฟล์ถูกแคชชั่วคราวเพื่อความเร็วและจะถูกลบอัตโนมัติ' },
        { q: 'vCard ไม่ขึ้นครบ?', a: 'แอปบางตัวอ่านคิวอาร์ไม่ตรงมาตรฐาน ลองใช้แอปสแกนอื่น' },
        { q: 'คิวอาร์ไม่ทำงาน ต้องทำอย่างไร?', a: 'ตรวจสอบ URL ให้ถูกต้อง เพิ่มความแตกต่างของสี และลองลบโลโก้เพื่อทดสอบ' },
        { q: 'รองรับเบราว์เซอร์ใดบ้าง?', a: 'Chrome, Firefox, Safari และ Edge เวอร์ชันใหม่รองรับทั้งหมด' },
      ],
    },
  },
  scanner: {
    title: 'สแกนคิวอาร์และบาร์โค้ด',
    subtitle: 'ใช้งานผ่านกล้อง อัปโหลดรูป หรือวางจากคลิปบอร์ดได้ทันที',
    cameraPermission: 'กรุณาอนุญาตการเข้าถึงกล้องในเบราว์เซอร์',
    result: 'ผลลัพธ์',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    open: 'เปิดลิงก์',
    delete: 'ลบ',
    scanAgain: 'สแกนอีกครั้ง',
    privacy: 'ประมวลผลทั้งหมดบนเบราว์เซอร์ของคุณ ไฟล์ไม่ถูกส่งขึ้นเซิร์ฟเวอร์',
    upload: 'อัปโหลดรูป',
    paste: 'วาง (Ctrl+V)',
    drop: 'ลากรูปมาวางที่นี่',
    retry: 'ลองใหม่',
    errorAccessDenied: 'ปฏิเสธการเข้าถึงกล้อง',
    errorCamera: 'เปิดสิทธิ์ให้กล้องแล้วลองใหม่อีกครั้ง',
    initializing: 'กำลังเปิดกล้อง...',
    cameraActive: 'กล้องพร้อมใช้งาน',
    scannedItems: 'ประวัติการสแกน',
    recentScans: 'รายการล่าสุด (จัดเก็บในเครื่อง)',
    clickToUpload: 'คลิกเพื่ออัปโหลด',
    newBadge: 'ใหม่',
    tabCameraMobile: 'กล้อง',
    tabCameraDesktop: 'สแกนด้วยกล้อง',
    emptyState: {
      title: 'ยังไม่มีการสแกน',
      desc: 'เริ่มได้โดยการอัปโหลดรูปหรือเปิดแท็บกล้อง',
    },
    highlights: {
      title: 'สแกนรวดเร็วและเป็นส่วนตัว',
      items: [
        { title: 'ถอดรหัสบนอุปกรณ์', desc: 'ค่าเริ่มต้นไม่อัปโหลดไฟล์ ปลอดภัยสำหรับ URL และข้อมูลสำคัญ.' },
        { title: 'รองรับหลายฟอร์แมต', desc: 'ทั้ง QR, UPC/EAN, Code 128, ITF และอื่น ๆ.' },
        { title: 'การทำงานที่รวดเร็ว', desc: 'ลากไฟล์ วางภาพหน้าจอ หรือสลับไปสแกนสดได้ทันที.' },
        { title: 'ยอดเยี่ยมบนมือถือ', desc: 'UI และลำดับการใช้กล้องถูกปรับให้เหมาะกับโทรศัพท์และจอขนาดเล็ก.' },
      ],
    },
    intro: {
      title: 'สแกนเนอร์ออนไลน์ที่ปลอดภัย',
      body: 'รองรับ QR, UPC, EAN, ITF และอีกหลายรูปแบบโดยไม่ต้องลงแอป',
    },
    howTo: {
      title: 'วิธีใช้งาน',
      methods: [
        { title: 'อัปโหลดรูป', steps: ['คลิก “อัปโหลดรูป”', 'เลือกไฟล์', 'รอผลลัพธ์'] },
        { title: 'โหมดกล้อง', steps: ['เปิดแท็บกล้อง', 'อนุญาตการใช้งาน', 'หันกล้องไปยังโค้ด'] },
      ],
    },
    features: {
      title: 'จุดเด่น',
      items: [
        { title: 'ฟรีและไม่จำกัด', desc: 'ไม่มีค่าใช้จ่ายหรือเพดานการใช้งาน' },
        { title: 'รองรับหลายฟอร์แมต', desc: 'อ่านได้ทั้ง QR และบาร์โค้ดยอดนิยม' },
        { title: 'ปลอดภัย', desc: 'ข้อมูลไม่ถูกส่งไปที่เซิร์ฟเวอร์ภายนอก' },
      ],
    },
    useCases: {
      title: 'เหมาะสำหรับ',
      items: [
        { title: 'การตลาดและร้านอาหาร', desc: 'ตรวจสอบเมนูดิจิทัลและแคมเปญคิวอาร์' },
        { title: 'คลังสินค้า', desc: 'เช็คบาร์โค้ดสินค้าอย่างรวดเร็ว' },
        { title: 'ผู้ใช้งานทั่วไป', desc: 'เข้าถึง Wi-Fi ฟอร์มหรือข้อมูลต่าง ๆ อย่างปลอดภัย' },
      ],
    },
    faq: {
      title: 'FAQ สแกนเนอร์',
      items: [
        { q: 'สแกนบาร์โค้ดได้ไหม?', a: 'ได้ รองรับฟอร์แมตสายการผลิตหลักทั้งหมด' },
        { q: 'วางภาพจากคลิปบอร์ดได้หรือไม่?', a: 'ได้ กด Ctrl+V หรือ Cmd+V เพื่อวางรูปที่คัดลอกไว้' },
        { q: 'ผลลัพธ์ถูกบันทึกไว้หรือเปล่า?', a: 'จัดเก็บเฉพาะในเครื่องคุณ สามารถลบออกเมื่อไรก็ได้' },
        { q: 'ใช้แบบออฟไลน์ได้หรือไม่?', a: 'การอัปโหลดรูปใช้งานออฟไลน์ได้ ส่วนโหมดกล้องต้องอนุญาตฮาร์ดแวร์' },
      ],
    },
  },
  blog: {
    title: 'บทความและแรงบันดาลใจ',
    subtitle: 'รวมแนวคิดการตลาดและอัปเดตผลิตภัณฑ์เกี่ยวกับคิวอาร์โค้ด',
    readMore: 'อ่านเพิ่มเติม',
    back: 'กลับไปหน้าบล็อก',
    notFound: 'ไม่พบบทความ',
  },
  common: {
    footer: 'แพลตฟอร์มสร้างและจัดการคิวอาร์โค้ดครบวงจรสำหรับธุรกิจยุคใหม่',
    privacy: 'ความเป็นส่วนตัว',
    terms: 'ข้อกำหนด',
    contact: 'ติดต่อ',
    scanToOpen: 'สแกนเพื่อเปิดบนมือถือ',
    help: 'ศูนย์ช่วยเหลือ',
    free: 'ฟรี',
    product: 'ผลิตภัณฑ์',
    resources: 'ทรัพยากร',
    company: 'บริษัท',
    api: 'API (เร็ว ๆ นี้)',
    systemStatus: 'สถานะระบบปกติ',
    footerDesc:
      'YesQRCode คือเครื่องมือสร้างและสแกนคิวอาร์ที่เร็ว ปลอดภัย และฟรีตลอดไป เหมาะสำหรับแบรนด์ นักออกแบบ และครีเอเตอร์ในประเทศไทย',
  },
};
